import { BaseRepository } from "@/repository/base";
import { IEvent } from "@/schemas/IEvent";

class EventRepository extends BaseRepository<IEvent> {}
const eventRepository = new EventRepository("user_events");

export default eventRepository;
